import { TSupportPage } from '@/reseller/reseller.types';

export const SUPPORT_PAGES: Record<TSupportPage, string> = {
  documentation: 'https://docs.softwaredefinedautomation.io/sew',
  customer_support:
    'https://www.sew-eurodrive.de/meta-pages/web-contact-form-in-page.html',
  security_incident_reporting:
    'https://www.sew-eurodrive.de/meta-pages/content-page-wo-margin-column.html',
};
